import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { CONFIGURE } from './types';

const deviceConfigureActionPayloadSchema = Joi.object().keys({
  ID: Joi.string().required(),
  type: Joi.string().default('not-defined'),
  make: Joi.string().default('not-defined'),
  version: Joi.string().default('not-defined'),
  userAgent: Joi.string().default('not-defined'),
  DNT: Joi.boolean().default(true),
});

export const deviceConfigureAction = actionCreator(CONFIGURE, deviceConfigureActionPayloadSchema);
